import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Returns the URL only when it is plain http(s), so user-supplied links can't run `javascript:`. */
export function safeExternalUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  try {
    const parsed = new URL(url.trim(), window.location.origin)
    return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed.href : undefined
  } catch {
    return undefined
  }
}

/** Event descriptions are stored entity-encoded by the admin editor; this yields the HTML. */
export function decodeEntities(html: string): string {
  const txt = document.createElement("textarea")
  txt.innerHTML = html
  return txt.value
}
